import React, { useState, useEffect } from "react";
import PackageCard from "./PackageCard";
import { db } from "../../firebase";
import { doc, getDoc, getDocs, collection } from "firebase/firestore";
import {
  TextField,
  Select,
  MenuItem,
  Grid,
  InputLabel,
  FormControl,
} from "@mui/material";

const PackagesSearch = ({ packages, setPackages }) => {
  const [filteredPackages, setFilteredPackages] = useState(packages);
  const [packageName, setPackageName] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedExperience, setSelectedExperience] = useState("");
  const [duration, setDuration] = useState("");
  const [bestSeason, setBestSeason] = useState("");
  const [showFilters, setShowFilters] = useState(false)

  const countries = [...new Set(packages.map((pkg) => pkg.country))];
  const cities = selectedCountry
    ? [
        ...new Set(
          packages
            .filter((pkg) => pkg.country === selectedCountry)
            .map((pkg) => pkg.city)
        ),
      ]
    : [];
  const experiences = [...new Set(packages.flatMap((pkg) => pkg.experience))];
  const bestSeasons = [
    ...new Set(packages.map((pkg) => pkg.destination?.bestSeason)),
  ];

  useEffect(() => {
    const applyFilters = () => {
      let result = packages;

      // Filter by package name
      if (packageName) {
        result = result.filter((pkg) =>
          pkg.title.toLowerCase().includes(packageName.toLowerCase())
        );
      }

      // Filter by price
      if (minPrice) {
        result = result.filter(
          (pkg) => parseInt(pkg.price) >= parseInt(minPrice)
        );
      }
      if (maxPrice) {
        result = result.filter(
          (pkg) => parseInt(pkg.price) <= parseInt(maxPrice)
        );
      }

      // Filter by country and city
      if (selectedCountry) {
        result = result.filter((pkg) => pkg.country === selectedCountry);
      }
      if (selectedCity) {
        result = result.filter((pkg) => pkg.city === selectedCity);
      }

      // Filter by experience
      if (selectedExperience) {
        result = result.filter((pkg) =>
          pkg.experience.includes(selectedExperience)
        );
      }

      // Filter by duration
      if (duration) {
        result = result.filter((pkg) => pkg.duration === duration);
      }

      // Filter by best season
      if (bestSeason) {
        result = result.filter(
          (pkg) => pkg.destination.bestSeason === bestSeason
        );
      }

      setFilteredPackages(result);
    };

    applyFilters();
  }, [
    packageName,
    minPrice,
    maxPrice,
    selectedCountry,
    selectedCity,
    selectedExperience,
    duration,
    bestSeason,
    packages,
  ]);

  return (
    <div className="search-container">
      <div className="page-banner-sec">
          <div className="banner-img">
            <h1>Find a Luxury Travel Package</h1>
          </div>
          <div className="filter-container">
            <div className="filter-section">
              <div className="search-bar-container">
                <TextField
                  fullWidth
                  label="Search by Package Name"
                  value={packageName}
                  onChange={(e) => setPackageName(e.target.value)}
                />
              </div>

              <button type="button" className="filters-btn" onClick={() => setShowFilters(!showFilters)}>
                <span>
                  <i class="bi bi-filter"></i> Filter
                </span>
                {showFilters ? <i class="bi bi-caret-up-fill"></i> : <i class="bi bi-caret-down-fill"></i>}
              </button>
              
              <div className={`filter-inputs ${showFilters ? 'active' : ''}`}>
                <TextField
                  fullWidth
                  label="Min Price"
                  type="number"
                  value={minPrice}
                  onChange={(e) => setMinPrice(e.target.value)}
                />

                <TextField
                  fullWidth
                  label="Max Price"
                  type="number"
                  value={maxPrice}
                  onChange={(e) => setMaxPrice(e.target.value)}
                />
                <FormControl fullWidth>
                  <InputLabel>Country</InputLabel>
                  <Select
                    value={selectedCountry}
                    onChange={(e) => {
                      setSelectedCountry(e.target.value);
                      setSelectedCity(""); // Reset city when country changes
                    }}
                  >
                    <MenuItem value="">Country</MenuItem>
                    {countries.map((country) => (
                      <MenuItem key={country} value={country}>
                        {country}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {selectedCountry && (
                    <FormControl fullWidth>
                      <InputLabel>Select City</InputLabel>
                      <Select
                        value={selectedCity}
                        onChange={(e) => setSelectedCity(e.target.value)}
                      >
                        <MenuItem value="">City</MenuItem>
                        {cities.map((city) => (
                          <MenuItem key={city} value={city}>
                            {city}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                )}

                <FormControl fullWidth>
                  <InputLabel>Experience</InputLabel>
                  <Select
                    value={selectedExperience}
                    onChange={(e) => setSelectedExperience(e.target.value)}
                  >
                    <MenuItem value="">Select Experience</MenuItem>
                    {experiences.map((experience) => (
                      <MenuItem key={experience} value={experience}>
                        {experience}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <TextField
                  fullWidth
                  label="Duration (days)"
                  type="number"
                  value={duration}
                  onChange={(e) => setDuration(e.target.value)}
                />

                {/* <FormControl fullWidth>
                  <InputLabel>Select Best Season</InputLabel>
                  <Select
                    value={bestSeason}
                    onChange={(e) => setBestSeason(e.target.value)}
                  >
                    <MenuItem value="">Select Best Season</MenuItem>
                    {bestSeasons.map((season) => (
                      <MenuItem key={season} value={season}>
                        {season}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl> */}
              </div>
            </div>
          </div>
      </div>
      <div className="packages-list">
        {filteredPackages.length > 0 ? (
          filteredPackages.map((pkg) => <PackageCard key={pkg.id} pkg={pkg} />)
        ) : (
          <p>No packages found</p>
        )}
      </div>
    </div>
  );
};

export default PackagesSearch;
